import { render } from "./PriceGroupItemsView.vue?vue&type=template&id=6c7d4dea"
import script from "./PriceGroupItemsView.vue?vue&type=script&lang=js"
export * from "./PriceGroupItemsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__